export default "__VITE_ASSET__7PHUJgSb__"